import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAdmin } from '../../utilities/userUtilities';
import { CircularProgress } from '@mui/material';

const ProtectedAdminRoute = ({ children }) => {
    const accountDetails = useSelector(state => state.app.accountDetails);
    const gettingAccountDetails = useSelector(state => state.app.gettingAccountDetails);
    
    const isUserAdmin = isAdmin(accountDetails?.roles);
    const accountDetailsLoaded = Boolean(accountDetails?.email);
    const hasToken = Boolean(localStorage.getItem('Token'));

    if (gettingAccountDetails || (hasToken && !accountDetailsLoaded)) {
        return <CircularProgress size={80} />;
    }

    if (!isUserAdmin) {
        return <Navigate to="/not-found" replace />;
    }

    return children;
};

export default ProtectedAdminRoute;
